import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { useAuthContext } from '@/contexts/AuthContext';
import { DunningService } from '@/api';

export interface DunningCockpitParams {
  stage?: string;
  search?: string;
  sort?: string;
  order?: 'asc' | 'desc';
  limit: number;
  offset: number;
}

export const dunningWorkflowKeys = {
  all: ['dunning-workflows'] as const,
  list: (params: DunningCockpitParams) =>
    [...dunningWorkflowKeys.all, 'list', params] as const,
  detail: (id: string) => [...dunningWorkflowKeys.all, 'detail', id] as const,
};

export function useDunningWorkflows(params: DunningCockpitParams) {
  const { isSignedIn } = useAuth();
  const { isAuthReady } = useAuthContext();

  return useQuery({
    queryKey: dunningWorkflowKeys.list(params),
    queryFn: () =>
      DunningService.getApiV1DunningWorkflows(
        params.stage,
        params.search,
        params.sort,
        params.order,
        params.limit,
        params.offset,
      ),
    enabled: isSignedIn && isAuthReady,
    staleTime: 30_000,
  });
}

export function useDunningWorkflowDetail(workflowItemId: string | null) {
  const { isSignedIn } = useAuth();
  const { isAuthReady } = useAuthContext();

  return useQuery({
    queryKey: workflowItemId
      ? dunningWorkflowKeys.detail(workflowItemId)
      : ['dunning-workflows', 'detail', 'none'],
    queryFn: () => DunningService.getApiV1DunningWorkflows1(workflowItemId as string),
    enabled: !!workflowItemId && isSignedIn && isAuthReady,
    staleTime: 15_000,
  });
}
